export default "__VITE_ASSET__89b312d8__"